import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCircleComponent } from './simple-icons-circle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCircleComponent ],
    exports:      [ SimpleIconsCircleComponent ],
    bootstrap:    []
})
export class SimpleIconsCircleModule {}
